import type { FunctionComponent } from 'react'
import React, { Fragment } from 'react'
import {
  SelectWrapper,
  SelectTitle,
  CustomInput,
  SelectResultsWrapper,
  CustomSelectResult
} from './Selects.styles'

interface UserPublicInfo {
  id: number
  name: string
}

interface StudentSelectProps {
  noNameFound: boolean
  selectedName: string
  namesFound: UserPublicInfo[]
  searchMatchingNames: (
    event: string,
    searchByEnrollmentNumber: boolean
  ) => void
  eraseField: (event) => void
  handleOptionClicked: (obj) => void
  shouldSearchByEnrollmentNumber?: boolean
}

const StudentSelect: FunctionComponent<StudentSelectProps> = ({
  noNameFound,
  selectedName,
  namesFound,
  eraseField,
  searchMatchingNames,
  handleOptionClicked,
  shouldSearchByEnrollmentNumber
}) => {
  const selectTitle = shouldSearchByEnrollmentNumber
    ? 'Número de matrícula'
    : 'Nome completo'
  const selectHelpText = shouldSearchByEnrollmentNumber
    ? 'Digite o número de matrícula do aluno'
    : 'Digite o nome e sobrenome'

  return (
    <Fragment>
      <SelectWrapper>
        <Fragment>
          <SelectTitle error={noNameFound || undefined}>
            {selectTitle}
          </SelectTitle>
          <CustomInput
            error={noNameFound || undefined}
            value={selectedName || ''}
            helpText={selectHelpText}
            onKeyDown={event => eraseField(event)}
            onChange={event =>
              searchMatchingNames(
                event.target.value,
                shouldSearchByEnrollmentNumber
              )
            }
          />
        </Fragment>
      </SelectWrapper>
      <SelectResultsWrapper>
        {Boolean(namesFound.length) &&
          namesFound.map(nameObj => (
            <CustomSelectResult
              key={nameObj.id}
              onClick={() => handleOptionClicked(nameObj)}
            >
              {nameObj.name}
            </CustomSelectResult>
          ))}
      </SelectResultsWrapper>
    </Fragment>
  )
}

export default StudentSelect
